export const iconFontAwesomeReligionDharmachakra = (
	<i className="fa-solid fa-dharmachakra"></i>
);
